import { TableProps } from 'antd/es/table';

export const mapColumns: TableProps['columns'] = [
  {
    title: 'DATE',
    dataIndex: 'date',
    key: 'id',
    ellipsis: false,
  },
  {
    title: 'IN TIME',
    dataIndex: 'inTime',
    ellipsis: false,
  },
  {
    title: 'OUT TIME',
    dataIndex: 'outTime',
    ellipsis: false,
  },
  {
    title: 'REMARKS',
    dataIndex: 'remarks',
    ellipsis: false,
  },
];
